export default __webpack_public_path__ + "static/media/us.4d69f22e.svg";